<template>
  <q-dialog
    :visible="isVisible"
    title="处理意见"
    width="40%"
    :innerScroll="false"
    :showFooter="false"
    @close="onClose"
  >
    <el-table
      :data="recordData"
      v-loading="loading"
      border
      :height="300"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      :header-cell-style="{
        backgroundColor: '#FAFAFA',
        textAlign: 'center',
      }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column
        prop="afterModify"
        label="处理意见"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="createdBy"
        label="操作人"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="createdDate"
        label="操作时间"
        :show-overflow-tooltip="true"
      ></el-table-column>
    </el-table>
  </q-dialog>
</template>

<script>
export default {
  name: 'AdjustRecordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      loading: false,
      recordData: []
    }
  },
  watch: {
    visible(val) {
      if (val && this.row) {
        this.fetchData()
      }
    }
  },
  methods: {
    onClose() {
      this.isVisible = false
    },
    fetchData() {
      this.loading = true
      this.$q.productModelDetails
        .queryProductSaleDetailRecord({ fragment: [this.row.productCode] })
        .then((res) => {
          if (res.code === '200') {
            this.recordData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
